import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStep {
  id: string;
  label: string;
  status: 'pending' | 'loading' | 'complete' | 'error';
}

interface LoadingOverlayProps {
  steps: LoadingStep[];
}

export default function LoadingOverlay({ steps }: LoadingOverlayProps) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-dark-800 rounded-lg p-6 max-w-md w-full space-y-6">
        <h2 className="text-xl font-semibold text-center">Loading Your Data</h2>
        
        <div className="space-y-4">
          {steps.map((step) => (
            <div key={step.id} className="flex items-center gap-3">
              {step.status === 'loading' ? (
                <Loader2 className="w-5 h-5 text-primary-500 animate-spin" />
              ) : step.status === 'complete' ? (
                <div className="w-5 h-5 rounded-full bg-green-500" />
              ) : step.status === 'error' ? (
                <div className="w-5 h-5 rounded-full bg-red-500" />
              ) : (
                <div className="w-5 h-5 rounded-full bg-dark-600" />
              )}
              
              <span className={
                step.status === 'complete' ? 'text-green-500' :
                step.status === 'error' ? 'text-red-500' :
                step.status === 'loading' ? 'text-primary-500' :
                'text-gray-400'
              }>
                {step.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}